import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader } from '../../components/components'
import AdminsTable from '../../components/Tables/AdminsTable'

const Admins = () => {
    return (
        <AdminSidebarLayout currentPath="/manage">
            <div className="bg-[#F5F5F5] dark:bg-[#121212] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <AdminsTable/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default Admins
